import locales from "locale-codes";

const getFormatTemplate = (locale: $TSFixMe) => {
  const dateTemplate = new Intl.DateTimeFormat(locale).format(new Date());
  const numberTemplate = new Intl.NumberFormat(locale).format(1234.56);
  const currencyTemplate = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "USD",
  }).format(1234.56);

  return { dateTemplate, numberTemplate, currencyTemplate };
};

export const getLocaleFormat = (locale: $TSFixMe) => {
  if (!locale) return null;
  const localeFormat = getFormatTemplate(locale);
  return `${localeFormat.dateTemplate} | ${localeFormat.numberTemplate} | ${localeFormat.currencyTemplate}`;
};

export const getLocaleOption = (locale: $TSFixMe) => {
  if (!locale) return null;

  const localeData = locales.getByTag(locale);
  if (!localeData) return null;

  return {
    label: localeData.location
      ? `${localeData.name} (${localeData.location})`
      : localeData.name,
    identifier: localeData.tag,
  };
};

export const getLocales = () => {
  const validLocales = locales.all.filter((locale) => {
    try {
      Intl.DateTimeFormat(locale.tag);
      return true;
    } catch {
      return false;
    }
  });

  return validLocales.map((locale) => ({
    label: locale.location
      ? `${locale.name} (${locale.location})`
      : locale.name,
    identifier: locale.tag,
  }));
};
